export const CAN_SORT_COLUMNS = ['name', 'enabled', 'favourite'];

export const SCHEDULE_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  BROKEN: 'BROKEN',
  SUCCESS: 'SUCCESS',
  PAUSED: 'PAUSED'
};

export const SCHEMA_SELECTOR = [
  { value: 'media', title: 'Media' },
  { value: 'device', title: 'Device' },
  { value: 'dataset', title: 'Dataset' },
  { value: 'monitor', title: 'Monitor objects' },
  { value: 'stat', title: 'Statistic objects' },
  { value: 'application', title: 'Application' }
];
